import {
  FINANCIAL_PAYLOAD_DECIMAL_PLACES,
  roundDecimalHalfUp,
} from './decimal-round.util';
import { DocumentSubType } from '../interfaces/invoice.interface';

/** True when payload line mapping must align return reference pricing with API math. */
export function isReturnDocumentPayload(formData: {
  documentSubTypeId?: number | string | null;
  documentType?: number | string | null;
} | null | undefined): boolean {
  const dt = formData?.documentSubTypeId ?? formData?.documentType;
  return (
    dt === DocumentSubType.SalesReturn ||
    dt === DocumentSubType.PurchesReturn ||
    dt === 2 ||
    dt === 4
  );
}

/**
 * Unit net sent to the API — prefers unrounded `payloadUnitNet` over display `price`.
 * Display controls stay at UI precision; payload keeps up to 6 dp for backend parity.
 */
export function resolvePayloadUnitNet(
  line: {
    payloadUnitNet?: number | string | null;
    price?: number | string | null;
  } | null | undefined,
): number {
  const dp = FINANCIAL_PAYLOAD_DECIMAL_PLACES;
  const payloadUnitNet = Number(line?.payloadUnitNet);
  if (Number.isFinite(payloadUnitNet) && payloadUnitNet > 0) {
    return roundDecimalHalfUp(payloadUnitNet, dp);
  }

  return roundDecimalHalfUp(Number(line?.price) || 0, dp);
}

/** Derive payload unit net from a tax-inclusive line target (return rows). */
export function derivePayloadUnitNetFromTargetLineTotal(
  targetLineTotal: number,
  quantity: number,
  vatPercent: number,
): number {
  const qty = Number(quantity) || 0;
  const target = Number(targetLineTotal) || 0;
  const vat = Number(vatPercent) || 0;
  if (qty <= 0 || target <= 0) {
    return 0;
  }
  const taxFactor = vat > 0 ? 1 + vat / 100 : 1;
  const rawLineNet = vat > 0 ? target / taxFactor : target;
  return rawLineNet / qty;
}
